import { createSlice } from "@reduxjs/toolkit";

/*
 * Mit diesen Bereich der Authentifizierung nutzen
 * wir den Slice nur dafür, das Token und das
 * Kennzeichen, dass authentifiziert wurde zu
 * speichern. 
 */


const authenticationKey = 'tournament/key/';

// Initiales Kennzeichen für die Authentifizierung
const initialState = 
{
  isAuthenticated : false,
  token           : "",    
};


// Der Reducer ist für das Setzen und Löschen der 
// Authentifizierungskennungen relevant. Mit dem 
// Slicer dürfen wir den Status auch direkt 
// überschreiben
export const authSlice = createSlice(
  {
    name: "auth",
    
    initialState,

    reducers: 
    {
      setAuthToken: (state, action) =>
      {
        state.token = action.payload;
        if (state.token)
        {
          state.isAuthenticated = true;
          window.sessionStorage.setItem(authenticationKey, state.token);
          //window.localStorage.setItem(authenticationKey, state.token);
        }
        else
        {
          state.isAuthenticated = false;
          window.sessionStorage.removeItem(authenticationKey);
          //window.localStorage.removeItem(authenticationKey);
        }
      },

      reloadAuthToken: (state, action) =>
      {
        if (!state.isAuthenticated)
        {
          let token = window.sessionStorage.getItem(authenticationKey);
          //let token = window.localStorage.getItem(authenticationKey);
          if (token)
          {
            state.isAuthenticated = true;
            state.token = token;
          }
        }
      }
    },
  }
);
  
// Aktionen und Reducer extrahieren
const { actions, reducer } = authSlice

// Einzelaktionen aus den Actions herausziehen
export const { setAuthToken, reloadAuthToken } = actions

// Und dann schieben wir noch den Reducer heraus
export default reducer